import { io } from 'socket.io-client'
import currentOutputSlug from '../composables/currentOutputSlug'

const params = new URLSearchParams(window.location.search)
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
const directorProtocol = params.get('directorProtocol') || (isLocal && 'ws') || 'wss'
const directorHost = params.get('directorHost') || '127.0.0.1'
const directorPort = params.get('directorPort') || (isLocal && '6060') || '443'

const socketUrl = `${directorProtocol}://${directorHost}:${directorPort}`

export default defineNuxtPlugin(() => {
  const debugStore = useDebugStore()

  const sceneStore = useSceneStore()
  const sceneItemsStore = useSceneItemsStore()
  const themeStore = useThemeStore()

  const socket = io(socketUrl, { transports: ['websocket'] })

  let firstChange = true

  socket.on('connect', () => {
    console.log('Connected to Muxo Director')

    socket.emit('join', { output: currentOutputSlug })
  })

  socket.on('disconnect', () => {
    console.error('Disconnected from Muxo Director')
  })

  socket.on('connect_error', (error) => {
    console.error('Muxo Director error', error)
  })

  socket.on('change', ({ theme, scene, items }) => {
    if (debugStore.ignoreDirectorUpdates) {
      return
    }

    const formattedDate = () => {
      const date = new Date()
      return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}`
    }

    console.group('RECEIVED CHANGE FROM DIRECTOR', formattedDate())
    console.log('Theme', theme)
    console.log('Scene', scene)
    console.log('Items:', items)
    console.log('Types:', items.map((item) => item.type).join(', '))
    console.groupEnd()

    // TODO: This is a hack to prevent a race condition where the data is set but nobody is listening yet.
    if (firstChange) {
      firstChange = false
      setTimeout(() => {
        themeStore.theme = theme
        sceneStore.scene = scene
        sceneItemsStore.setItems(items)
      }, 1000)
    } else {
      themeStore.theme = theme
      sceneStore.scene = scene
      sceneItemsStore.setItems(items)
    }
  })

  socket.on('refresh', () => {
    window.location.reload()
  })

  socket.on('error', (data) => {
    console.log('Error', data)
  })
})
